import { MINUTES_PER_DAY, selectedSegments } from "../../../../components/RRule/timeline-range.js";
//#region src/modules/ServicePeriods/activity-evals/relative-window/relative-window-geometry.ts
function wrapClock(min) {
	return (min % MINUTES_PER_DAY + MINUTES_PER_DAY) % MINUTES_PER_DAY;
}
function emptyRelativeWindow(periodDurationMin) {
	return {
		durationMinutes: Math.max(1, periodDurationMin),
		fromStartMinutes: 0
	};
}
function clampRelativeWindow(window, periodDurationMin) {
	const maxStart = Math.max(0, periodDurationMin - 1);
	const fromStartMinutes = Math.min(Math.max(0, window.fromStartMinutes), maxStart);
	const maxDuration = Math.max(1, periodDurationMin - fromStartMinutes);
	const durationMinutes = Math.min(Math.max(1, window.durationMinutes), maxDuration);
	return {
		...window,
		durationMinutes,
		fromStartMinutes
	};
}
function evalClockFromPeriod(periodFromMin, fromStartMinutes) {
	return wrapClock(periodFromMin + fromStartMinutes);
}
function clampClockToPeriod(clockMin, periodFromMin, periodDurationMin) {
	const clock = wrapClock(clockMin);
	if (periodDurationMin >= 1440) return clock;
	const offset = wrapClock(clock - periodFromMin);
	if (offset <= periodDurationMin) return evalClockFromPeriod(periodFromMin, offset);
	return offset - periodDurationMin <= 1440 - offset ? evalClockFromPeriod(periodFromMin, periodDurationMin) : wrapClock(periodFromMin);
}
function relativeWindowSegments(periodFromMin, periodDurationMin, window) {
	const clamped = clampRelativeWindow(window, periodDurationMin);
	const fromClock = evalClockFromPeriod(periodFromMin, clamped.fromStartMinutes);
	return selectedSegments(fromClock, wrapClock(fromClock + clamped.durationMinutes), clamped.durationMinutes);
}
function relativeWindowFromClockRange(periodFromMin, periodDurationMin, fromClockMin, toClockMin) {
	const fromClock = clampClockToPeriod(fromClockMin, periodFromMin, periodDurationMin);
	const toClock = clampClockToPeriod(toClockMin, periodFromMin, periodDurationMin);
	let fromStartMinutes = wrapClock(fromClock - periodFromMin);
	if (fromStartMinutes >= periodDurationMin) fromStartMinutes = 0;
	let durationMinutes = wrapClock(toClock - fromClock);
	if (durationMinutes === 0) durationMinutes = MINUTES_PER_DAY;
	return clampRelativeWindow({
		durationMinutes,
		fromStartMinutes
	}, periodDurationMin);
}
//#endregion
export { clampClockToPeriod, clampRelativeWindow, emptyRelativeWindow, evalClockFromPeriod, relativeWindowFromClockRange, relativeWindowSegments };

//# sourceMappingURL=relative-window-geometry.js.map